// extracted by mini-css-extract-plugin
export default {"card":"Card_card__LzzZD","imgContainer":"Card_imgContainer__qzIWG","body":"Card_body__MqGZk","transparent":"Card_transparent__D3aRC"};